window.reRenderSlider = -1;
$(document).ready(function () {
  function getIndexOfCurrent(carouselSlides, selectedMedia) {
    let i = 0;
    carouselSlides.each(function(index, element) {
      if (element.getAttribute("data-media-alt") == selectedMedia) {
        i = index;
        return false;
      }
    });
    return i;
  }
  async function scrollToCurrent (selectedMedia) {
    const index = await getIndexOfCurrent($(".product .product-gallery__carousel .product-gallery__media[data-media-alt='"+selectedMedia+"']"), selectedMedia);
    window.reRenderSlider = index;
    
    document.querySelector(".product .product-gallery__carousel")?.select(index, {instant: true})
  }

  async function scrollToCurrentQuick (selectedMedia) {
    const index = await getIndexOfCurrent($("quick-buy-modal .product-gallery__carousel .product-gallery__media[data-media-alt='"+selectedMedia+"']"), selectedMedia);
    document.querySelector("quick-buy-modal .product-gallery__carousel")?.select(index, {instant: true})
  }
  
  function updateThumbnails() {
    window.reRenderSlider = -1
    var selectedMedia = $('.product .variant-picker input.style_variant[type="radio"]:checked').attr("data-featured-media");
    if (typeof selectedMedia != 'undefined') {
      let images = [];
      if(selectedMedia){$(".product button.product-gallery__thumbnail").attr('aria-current', false);}
      $(".product button.product-gallery__thumbnail").each(function () {
        var mediaAlt = $(this).attr("data-media-alt");
        if (mediaAlt === selectedMedia) {
          $(this).show();
          $(this).removeAttr("hidden");
        } else {
          if(selectedMedia){
            $(this).attr("hidden", "true");
          }
          else{
            $(this).removeAttr("hidden");
          }
        }
      });
      
      if(selectedMedia){scrollToCurrent(selectedMedia);}
      setTimeout(() => {
        if(selectedMedia){document.querySelector(".product button.product-gallery__thumbnail[data-media-alt='"+selectedMedia+"']")?.setAttribute("aria-current", true);}
        document.querySelectorAll(".product .product-gallery__carousel .product-gallery__media").forEach((item) => {
        Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach((img) => img.setAttribute("loading", "eager"));
        Array.from(item.querySelectorAll('video[preload="none"]')).forEach((video) => video.setAttribute("preload", "metadata"));
      });
      }, 0);
    }
  }

  function updateProduct() {
    var selectedMedia = $('.product .variant-picker input.style_variant[type="radio"]:checked').attr("data-featured-media");
    var visibleMedia = [];

    if (selectedMedia) {
      $(".product .product-gallery__media").each(function () {
        var mediaAlt = $(this).attr("data-media-alt");
        if (mediaAlt === selectedMedia) {
          $(this).removeAttr("hidden");
          visibleMedia.push($(this));
        } else {
          $(this).attr("hidden", "true");
        }
      });
    } else {
      $(".product .product-gallery__media").each(function () {
        $(this).removeAttr("hidden");
        visibleMedia.push($(this));
      });
    }
    updateCarouselDots(visibleMedia);
  }

  function updateQuickViewThumbnails() {
    var selectedMedia = $('quick-buy-modal .variant-picker input.style_variant[type="radio"]:checked').attr("data-featured-media");
    $("quick-buy-modal button.product-gallery__thumbnail").each(function () {
      var mediaAlt = $(this).attr("data-media-alt");
      if (mediaAlt === selectedMedia) {
        $(this).show();
        $(this).removeAttr("hidden");
      } else {
        $(this).hide();
      }
    });
    scrollToCurrentQuick(selectedMedia)
  }

  function updateQuickViewProduct() {
    var selectedMedia = $('quick-buy-modal .variant-picker input.style_variant[type="radio"]:checked').attr("data-featured-media");
    var visibleMedia = [];

    if (selectedMedia) {
      $("quick-buy-modal .product-gallery__media").each(function () {
        var mediaAlt = $(this).attr("data-media-alt");
        if (mediaAlt === selectedMedia) {
          $(this).removeAttr("hidden");
          visibleMedia.push($(this));
        } else {
          $(this).attr("hidden", "true");
        }
      });
    } else {
      $("quick-buy-modal .product-gallery__media").each(function () {
        $(this).removeAttr("hidden");
        visibleMedia.push($(this));
      });
    }
    updateCarouselDots(visibleMedia);
  }

  function updateCarouselDots(visibleMedia) {
    var $carouselNavigation = $("product-gallery carousel-navigation");
    $carouselNavigation.empty(); // Clear existing dots
    for (var i = 0; i < visibleMedia.length; i++) {
      var isCurrent = i === 0 ? "true" : "false";
      var activeClass = i === 0 ? "current-dot" : "";
      var $dot = $("<button>", {
        type: "button",
        class: "tap-area " + activeClass,
        "aria-current": isCurrent,
        "data-index": i,
      }).append(
        $("<span>", {
          class: "sr-only",
          text: "Go to item " + (i + 1),
        })
      );
      $carouselNavigation.append($dot);
    }

    // Attach event listeners to the dots
    $carouselNavigation.find("button").on("click", function () {
      var index = $(this).attr("data-index");
      showSlide(index, visibleMedia);
      $(this).addClass("current-dot").siblings().removeClass("current-dot");
    });
  }

  function showSlide(index, visibleMedia) {
    visibleMedia.forEach(function (media, i) {
      if (i == index) {
        media.removeAttr("hidden");
      } else {
        media.attr("hidden", "true");
      }
    });
  }
  
  let isScrolling = false;
  
  setTimeout(() => {
    updateThumbnails();
    updateProduct();
    updateQuickViewThumbnails();
    updateQuickViewProduct();
  }, 0)

  $(document).on("change", ".product variant-picker fieldset input.style_variant", function () {
    updateThumbnails();
    updateProduct();
    
  });
  
  $(document).on("change","quick-buy-modal .variant-picker fieldset input.style_variant", function () {
      updateQuickViewThumbnails();
      updateQuickViewProduct();
    }
  );

  $(".product-card__quick-add-button").click(function () {
    setTimeout(function () {
      updateQuickViewProduct();
    }, 2000);
  });

  if (jQuery(window).width() > 1099) {
    var scrollTop = 0;
    if (jQuery(window).scrollTop() > 90) {
      jQuery("header x-header").addClass("is-solid");
    }
  }

  $(document).on('click', '.scroll-arrow a', function (){
      const section = document.querySelector($(this).attr('href'));
      window.scrollTo({
        top: section?.offsetTop - 60,
        left: 0,
        behavior: 'smooth'
      });
  });
});


$(document).ready(function() {
  $('.custom-product-list .scroll-carousel').on('scroll', function() {
    $(this).css('scroll-behavior', 'smooth');
  });

  let isScrolling = false;
  $('.custom-product-list .scroll-carousel').on('wheel', function(e) {
    if (isScrolling) return;
    isScrolling = true;
    
    const delta = e.originalEvent.deltaY;
    const direction = delta > 0 ? 1 : -1;
    
    const scrollWidth = $(this).width();
    const scrollLeft = $(this).scrollLeft();
    
    $(this).animate({
      scrollLeft: scrollLeft + scrollWidth * direction
    }, 600, function() {
      isScrolling = false;
    });
    
    e.preventDefault();
  });
});

class CartAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    try {
      setTimeout(() => {
        const swiper = new Swiper(this, {
          loop: true,
          navigation: {
            nextEl: '.cart-announcementbar__next',
            prevEl: '.cart-announcementbar__prev',
          },
          autoplay: {
           delay: 3000,
         },
        });
  
        swiper.update();
      }, 1500);
    } catch (error) {
      console.log('cart announcement bar error', error);
    }
  }
}

customElements.define('cart-announcementbar', CartAnnouncementBar);